import React from "react";

export const IconAudioVisual = ({ handleClick = false }) => (
  <svg
    fill="none"
    viewBox="0 0 24 24"
    onClick={() => (handleClick ? handleClick() : null)}
  >
    <path
      d="m17.368 15.999v-0.1509c0-0.3731 0.2515-0.6789 0.6095-0.7691l4.3898-1.1738c0.0744-0.0199 0.1524-0.0224 0.228-0.0074 0.0755 0.015 0.1466 0.0471 0.2077 0.0939 0.0612 0.0469 0.1108 0.1071 0.145 0.1761 0.0341 0.069 0.052 0.145 0.0522 0.222v0.5531m0 3.0158v2.0115c0 0.3497-0.2245 0.6434-0.5531 0.7543l-0.5532 0.2011c-0.6512 0.2193-1.3075-0.262-1.3075-0.9554-0.0015-0.1782 0.0538-0.3522 0.1577-0.4968 0.104-0.1447 0.2513-0.2525 0.4206-0.3078l1.2824-0.4564c0.3286-0.1106 0.5531-0.4008 0.5531-0.7505zm0 0v-5.9827c-2e-4 -0.0385-0.0092-0.0765-0.0263-0.1109-0.0172-0.0345-0.042-0.0645-0.0726-0.0879-0.0306-0.0233-0.0662-0.0393-0.104-0.0468-0.0377-0.0074-0.0767-0.0061-0.1139 0.0039l-5.0136 1.348c-0.0875 0.0247-0.1644 0.0775-0.2189 0.1501-0.0545 0.0727-0.0836 0.1613-0.0829 0.2522v5.6825m0 0c0 0.3497-0.2245 0.6436-0.5531 0.7543l-1.3075 0.4526c-0.349 0.1176-0.5532 0.4329-0.5532 0.8046 0 0.6934 0.6669 1.1704 1.3075 0.9554l0.5532-0.2011c0.3286-0.1107 0.5531-0.4043 0.5531-0.7543v-2.0115z"
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="m10.908 14.694 3.8693-2.385c0.0539-0.0335 0.0985-0.0806 0.1294-0.1368 0.031-0.0562 0.0472-0.1196 0.0472-0.184s-0.0162-0.1278-0.0472-0.184c-0.0309-0.0562-0.0755-0.1033-0.1294-0.1368l-3.8693-2.385c-0.0555-0.03391-0.1188-0.05214-0.1834-0.05285-0.0647-7e-4 -0.1284 0.01615-0.1845 0.04884-0.0562 0.03269-0.1028 0.08003-0.1351 0.13717s-0.0491 0.12202-0.0488 0.18798v4.7692c-3e-4 0.066 0.0165 0.1309 0.0488 0.188s0.0789 0.1045 0.1351 0.1372c0.0561 0.0326 0.1198 0.0495 0.1845 0.0488 0.0646-7e-4 0.1279-0.0189 0.1834-0.0528z"
      fill="#000"
    />
    <path
      d="M14.0345 18.7931H4.83908C3.82338 18.7931 3 17.951 3 16.9122L3 6.88088C3 5.8421 3.82338 5 4.83908 5L19.5517 5C20.5674 5 21.3908 5.8421 21.3908 6.88088V9.5977"
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
  </svg>
);

export default IconAudioVisual;
